/**
 *
 * TeamAnalysis
 *
 */

import "./index.less"

import { CloseOutlined, LeftOutlined, SearchOutlined } from "@ant-design/icons"
import { Empty, Input, Select, Spin } from "antd"
import { HISTORICAL_ANALYSIS, ROLE_LEADER } from "../../../utils/constants"
import { LOCAL_ACTIVE_ROL, isModuleBySlug } from "../../../utils/storage"
import React, { Fragment } from "react"
import {
  getDimensionsWatcher,
  getDivisionsWatcher,
  getGraphicBarsWatcher,
  getMeasureColorRangeWatcher,
} from "./actions"
import {
  makeSelectDimensions,
  makeSelectDivisions,
  makeSelectDivisionsDrillDown,
  makeSelectDivisionsFilter,
  makeSelectGraphicBars,
  makeSelectIsLoading,
  makeSelectIsLoadingGraphicBars,
  makeSelectLevels,
  makeSelectMeasureInfo,
  makeSelectMeasureRangeColor,
  makeSelectMetric,
  makeSelectShowHistory,
  makeSelectSwitchMoreDimensions,
} from "./selectors"

import BlockFreemiumPageBlur from "components/BlockFreemiumPageBlur"
import ContainerDrillDown from "components/ContainerDrillDown"
import { Helmet } from "react-helmet"
import Layout from "components/Layout"
import { Link } from "react-router-dom"
import MultiBarChart from "components/MultiBarChart"
import ReportHeader from "containers/Report/Header"
import ResultTeamTable from "./ResultTeamTable"
import ResultTeamTableComponent from "./ResultTeamTableComponent"
import { compose } from "redux"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { debounce } from "lodash"
import injectReducer from "utils/injectReducer"
import injectSaga from "utils/injectSaga"
import reducer from "./reducer"
import saga from "./saga"
import { validate } from "../../../utils/functions"
import MeasurementColorRange from "../../../components/MeasurementColorRange"
import { loadTexts } from "../../../utils/i18n"

const { Option } = Select

/* eslint-disable react/prefer-stateless-function */
export class TeamAnalysis extends React.Component {
  intlTeamAnalysis = loadTexts("reports_team_analysis_view")
  state = {
    measure_id: this.props.match.params.id,
    selectedLevel: null,
    selectedDimension: null,
    search: "",
    idSegment: undefined,
    first_level:true
  }

  componentDidMount() {
    const {
      match: { params },
      location,
    } = this.props
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    const searchLocation = getUrlParams(location.search)
    let paramPath = { ...searchLocation }
    const idSegment = validate.empty(paramPath.id_segment)
      ? null
      : paramPath.id_segment
    this.props.graphicBarsWatcher({
      idMeasure: params.id,
      data: { switchBars: isHistoricalAnalysis ? 1 : 0 },
      id_segment: idSegment,
      first_level: this.state.first_level,
    })
    this.props.getDimensions({
      measure: this.state.measure_id,
      id_segment: idSegment,
    })
    this.loadDetails()
    this.setState({ first_level: false })
    this.props.getMeasureRangeColorWatcher({
      measure: this.state.measure_id,
    })

    this.setState({ idSegment })
  }

  loadDetails = () => {
    const {
      match: {
        params: { id },
      },
    } = this.props
    const searchLocation = getUrlParams(location.search)
    let paramPath = { ...searchLocation }
    const idSegment = validate.empty(paramPath.id_segment)
      ? null
      : paramPath.id_segment

    const params = {
      measure: this.state.measure_id,
      search: this.state.search,
      dimension: this.state.selectedDimension,
      level: this.state.selectedLevel,
      id_segment: idSegment,
      recipients: true,
    }

    this.props.getDivisions(params)

    if (this.props.graphicBars.data) {
      if (!Array.isArray(this.props.graphicBars.data[0])) {
        this.props.graphicBarsWatcher({
          idMeasure: id,
          data: {
            ...params,
            division: this.state.selectedLevel,
            switchBars: 0,
          },
        })
      }

      if (
        this.props.graphicBars.data.length &&
        Array.isArray(this.props.graphicBars.data[0])
      ) {
        this.props.graphicBarsWatcher({
          idMeasure: id,
          data: {
            ...params,
            division: this.state.selectedLevel,
            switchBars: 1,
          },
        })
      }
    }
  }

  searchWithDebounce = debounce(() => {
    this.loadDetails()
  }, 500)

  renderFilters = () => {
    const { dimensions, divisions_filter, divisions } = this.props
    const { measure_id, idSegment } = this.state
    const isUserLeader = LOCAL_ACTIVE_ROL() === ROLE_LEADER.toString()

    const dropDownOptionsComponent = () => {
      if (validate.empty(idSegment)) {
        return null
      }

      return (
        <>
          <Select
            placeholder="Seleccionar división"
            allowClear
            defaultValue={this.state.selectedLevel}
            style={{ width: 200, marginRight: 8 }}
            onChange={(s) => {
              this.setState({ selectedLevel: s }, () => this.loadDetails())
            }}>
            {divisions_filter
              .filter((obj, pos, arr) => {
                return (
                  arr
                    .map((mapObj) => mapObj.id_division)
                    .indexOf(obj.id_division) === pos
                )
              })
              .map((f, i) => (
                <Option key={i} value={f.id_division}>
                  {f.division_name}
                </Option>
              ))}
          </Select>
          <Select
            placeholder="Seleccionar dimensión"
            allowClear
            defaultValue={this.state.selectedDimension}
            style={{ width: 200, marginRight: 8 }}
            onChange={(s) => {
              this.setState({ selectedDimension: s }, () => this.loadDetails())
            }}>
            {dimensions.map((f, i) => (
              <Option key={i} value={f.id}>
                {f.name}
              </Option>
            ))}
          </Select>
        </>
      )
    }

    if (isUserLeader) {
      // divisions is teams
      return (
        <>
          <Select
            placeholder={this.intlTeamAnalysis.seletcLeaderPlaceHolder}
            allowClear
            style={{ width: 200, marginRight: 8 }}
            onChange={(s) => {
              this.props.history.push(
                `/reports/measure/${measure_id}/teams/${s}/dimensions`
              )
            }}>
            {divisions
              .filter((obj, pos, arr) => {
                return (
                  arr
                    .map((mapObj) => mapObj.id_position)
                    .indexOf(obj.id_position) === pos && !obj.current_leader
                )
              })
              .map((f, i) => (
                <Option key={i} value={f.id_position}>
                  {f.name}
                </Option>
              ))}
          </Select>
        </>
      )
    }

    return (
      <>
        {dropDownOptionsComponent()}
        <Input
          value={this.state.search}
          style={{ width: 200 }}
          placeholder={this.intlTeamAnalysis.selectTeamPlaceHolder}
          onChange={(e) => {
            this.setState({ search: e.target.value }, () => {
              this.searchWithDebounce()
            })
          }}
          suffix={
            this.state.search ? (
              <CloseOutlined
                className="collaborators-header-search-clear"
                onClick={() => {
                  this.setState({ search: "" }, () => {
                    this.searchWithDebounce()
                  })
                }}
              />
            ) : (
              <SearchOutlined />
            )
          }
        />
      </>
    )
  }

  renderIconQuestions = () => {
    const { measureColorRange } = this.props
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          marginTop: "20px",
          marginBottom: "12px",
        }}>
        <MeasurementColorRange measureColorRange={measureColorRange} />
      </div>
    )
  }

  render() {
    const {
      divisions,
      divisions_drilldown,
      isLoading,
      metric,
      match,
      history,
      measureInfo,
    } = this.props
    const { measure_id } = this.state
    const isUserLeader = LOCAL_ACTIVE_ROL() === ROLE_LEADER.toString()
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    const searchLocation = getUrlParams(location.search)
    let paramPath = { ...searchLocation }
    const idSegment = validate.empty(paramPath.id_segment)
      ? null
      : paramPath.id_segment
    return (
      <Layout>
        {isLoading ? (
          <Fragment>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "240px",
              }}>
              <Spin />
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <Helmet>
              <title>{this.intlTeamAnalysis.titlePage}</title>
              <meta
                name="description"
                content="Description of DivisionAnalysis"
              />
            </Helmet>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <ReportHeader
                showDownload
                preSelectExport={[null, ["team"]]}
                measure={measure_id}
                match={match}
                history={history}
              />
              <div
                style={{ position: "relative" }}
                className="ReportsDivisionAnalysis">
                <div className="ReportsDivisionAnalysis-header">
                  <div className="ReportsDivisionAnalysis-header-btn-back">
                    <span>
                      <Link
                        to={`/reports/measure/${measureInfo &&
                          measureInfo.id_survey_type}/${
                          this.props.match.params.id
                        }${idSegment ? `?id_segment=${idSegment}` : ""}`}>
                        <LeftOutlined /> {this.intlTeamAnalysis.link}
                      </Link>
                    </span>
                  </div>
                  <div>{this.renderFilters()}</div>
                </div>
                <h4>
                  {this.intlTeamAnalysis.resultBy}{" "}
                  {isUserLeader
                    ? this.intlTeamAnalysis.leader
                    : this.intlTeamAnalysis.team}
                  {measureInfo &&
                    measureInfo.segment_name &&
                    measureInfo.segment_name.length != 0 &&
                    ` - ${measureInfo.segment_name}`}
                </h4>
                {!isLoading &&
                Array.isArray(divisions) &&
                divisions.length === 0 ? (
                  <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                ) : (
                  <Fragment>
                    {this.props.showHistory &&
                    this.props.switchMoreDimensions ? (
                      <MultiBarChart
                        {...this.props.graphicBars}
                        match={this.props.match}
                        hasDataHistory={this.props.switchMoreDimensions}
                        loading={this.props.isLoadingGraphicBars}
                        calculationType={measureInfo.id_survey_calculation_type}
                        graphicBarsWatcher={this.props.graphicBarsWatcher}
                      />
                    ) : (
                      <div
                        style={{ marginTop: "1.25rem" }}
                        className="boxShadow">
                        <ContainerDrillDown
                          textLeyend="Organización"
                          isLoading={isLoading}
                          metric={metric}
                          data={divisions_drilldown}
                        />
                      </div>
                    )}

                    <div>
                      {this.renderIconQuestions()}
                      <ResultTeamTableComponent
                        dataSource={divisions}
                        isLoading={isLoading}
                        match={match}
                        measureInfo={measureInfo}
                        idSegment={idSegment}
                      />
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
            <BlockFreemiumPageBlur view="leadership-rank-leaders" />
          </Fragment>
        )}
      </Layout>
    )
  }
}

TeamAnalysis.propTypes = {
  // dispatch: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  dimensions: makeSelectDimensions(),
  divisions: makeSelectDivisions(),
  divisions_drilldown: makeSelectDivisionsDrillDown(),
  isLoading: makeSelectIsLoading(),
  metric: makeSelectMetric(),
  levels: makeSelectLevels(),
  divisions_filter: makeSelectDivisionsFilter(),
  graphicBars: makeSelectGraphicBars(),
  isLoadingGraphicBars: makeSelectIsLoadingGraphicBars(),
  showHistory: makeSelectShowHistory(),
  switchMoreDimensions: makeSelectSwitchMoreDimensions(),
  measureColorRange: makeSelectMeasureRangeColor(),
  measureInfo: makeSelectMeasureInfo(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDivisions: (params) => dispatch(getDivisionsWatcher(params)),
    getDimensions: (params) => dispatch(getDimensionsWatcher(params)),
    graphicBarsWatcher: (params) => dispatch(getGraphicBarsWatcher(params)),
    getMeasureRangeColorWatcher: (params) =>
      dispatch(getMeasureColorRangeWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "teamAnalysis", reducer })
const withSaga = injectSaga({ key: "teamAnalysis", saga })

export default compose(withReducer, withSaga, withConnect)(TeamAnalysis)
